<template>
  <component
    :is="tag"
    :class="$style['action-text']"
    :data-testid="testId"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <component
      :is="textComponent"
    >
      <slot
        name="default"
      />
    </component>
  </component>
</template>

<script lang="ts">
import { NuxtLink } from '#components'

export default defineComponent({
  name: 'ActionText',
  components: {
    Paragraph2: defineAsyncComponent(
      () => import('~/components-daisy/typography/paragraph-2/Paragraph2.vue'),
    ),
    NuxtLink: NuxtLink,
  },
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      required: true,
    },
    testId: {
      type: String,
      required: false,
      default: '',
    },
    textComponent: {
      type: String,
      required: false,
      default: 'Paragraph2',
    },
  },
  emits: ['click'],
})
</script>

<style lang="postcss" module>
.action-text {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  touch-action: manipulation;
  color: var(--color-primary-800);

  &:focus-visible,
  &:focus,
  &:hover {
    text-decoration: underline;
    text-underline-offset: 0.063rem;
    text-decoration-thickness: 0.125rem;
  }
}
</style>
